import type { EchographyAdditionalQuestionResponseData } from '@common/validation/customControls/echography/echographyAdditionalQuestionResponse';
import { CustomControlCode } from '@common/enums';
import { CustomControlRegistry } from '@frontend/components/pages/episodeCategory/customControls/customControlRegistry';
import { EchographyAdditionalQuestionResponseEdit } from './EchographyAdditionalQuestionResponseEdit';
import { EchographyAdditionalQuestionResponseRead } from './EchographyAdditionalQuestionResponseRead';

const code = CustomControlCode.EchographyAdditionalQuestionResponse;

CustomControlRegistry.instance.register<EchographyAdditionalQuestionResponseData>({
    EditElement: EchographyAdditionalQuestionResponseEdit,
    ReadElement: EchographyAdditionalQuestionResponseRead,
    code,
    version: 1,
});
